import type { FC, PropsWithChildren } from "react";

export const LimitHeaderTitle: FC<PropsWithChildren> = props => {
	const {
		children
	} = props;

	return (
		<h1 className="type-title">
			{children}
		</h1>
	);
};
